/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2AppointmentIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2AppointmentIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2AppointmentIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 13,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2AppointmentIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 13"
 style={{'--as-1-Z1VtcXE': alignSelf,'--mt-2-Z1VtcXE': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1VtcXE': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1VtcXE': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1VtcXE': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1VtcXE': opacity,'--w-10-Z1VtcXE': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1VtcXE': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1VtcXE': fill,'--a-7-Z1VtcXE': isAnimated ? animation : "none",'--sd-8-Z1VtcXE': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1VtcXE': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2AppointmentIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M3.857 1.357a.857.857 0 00-1.714 0v.857h-.857C.576 2.214 0 2.79 0 3.5v7.714c0 .71.576 1.286 1.286 1.286h9.428c.71 0 1.286-.576 1.286-1.286V3.5c0-.71-.576-1.286-1.286-1.286h-.857v-.857a.857.857 0 10-1.714 0v.857H3.857v-.857zm1.26 3.795c0-.185.15-.336.337-.336h1.092c.186 0 .337.15.337.336V6.49H8.22c.186 0 .336.15.336.336V7.92c0 .186-.15.336-.336.336H6.883v1.338c0 .185-.15.336-.337.336H5.454a.336.336 0 01-.337-.336V8.255H3.78a.336.336 0 01-.336-.336V6.826c0-.186.15-.336.336-.336h1.337V5.152z"
 style={{'--f-12-Z1VtcXE': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}